import React from 'react'
import TagGrid from './TagGrid'

export default function Tag() {
  return (
    <div>
      <TagGrid/>
    </div>
  )
}
